import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './ExitPopup.module.scss';
import { clickTracker, getContractTypeVal, getProjectId, pathsObj } from '../../lib/common';
import { onClickEvent } from '../../lib/gaAnalytics';
import { useLocalStorage } from '../../hooks';
import { handleImpressionsTrack } from '../../api';
import { useAuth } from '../../contexts/auth';

export default function ExitPopup({ handleClose }) {
  const navigate = useNavigate();
  const [selectedBusiness] = useLocalStorage('selectedBusiness', '');
  const queryParams = new URLSearchParams(window.location.search);
  const location = useLocation();
  const pageType = location.pathname.replace('/csportal', '').replace('/', '') || 'landing';
  const currentfaq = pathsObj?.[pageType] || '';
  const projectId = getProjectId();
  const [authState] = useAuth();

  useEffect(() => {
    const handleClickTrackers = async () => {
      if (currentfaq) {
        await clickTracker('cs_exitpopup', `${currentfaq?.toLowerCase()}_faq`);
        await onClickEvent(`${currentfaq}`, `${currentfaq}_Exit pop up`, 'Exit pop up view');
      }
    };
    handleClickTrackers();
  }, [currentfaq]);

  const handleFaqRedirection = async () => {
    document.body.style.overflow = 'unset';
    await clickTracker('cs_exitpopup_ticket', `${currentfaq?.toLowerCase()}_faq`);
    const contractVal = getContractTypeVal(projectId);
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `cta_raisecomplaint`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = '';
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
    }
    if (projectId === 'csportal' && ['paid', 'expiredShort'].includes(contractVal)) {
      // navigate('/csportal/create_ticket_new');
      navigate(
        `/csportal/create_ticket?parentId=${selectedBusiness?.parentid}&city=${
          selectedBusiness?.data_city
        }&vertical=${queryParams?.get('vertical') === 'leadDashBoard' ? 'leadDashBoard' : ''}&exitPopupFlag=1`,
      );
    } else {
      navigate(
        `/csportal/create_ticket?parentId=${selectedBusiness?.parentid}&city=${
          selectedBusiness?.data_city
        }&vertical=${queryParams?.get('vertical') === 'leadDashBoard' ? 'leadDashBoard' : ''}&exitPopupFlag=1`,
      );
    }
    handleClose();
  };

  return (
    <section className={`cs_modal ${styles.ExitModal}`}>
      <div className={`cs_modal_content cs_modal_animation cs_modal_up ${styles.ExitModal__Content} `}>
        <div className={`${styles.ExitModal__Body} cs_modal_body p-20`}>
          <img
            alt="exitmodalimage"
            className={`${styles.ExitModalImage}`}
            src="https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/exitmodalimage.svg"
            width={125}
            height={125}
          />
          <div className="font15 fw500 color111 mt-20">Unable to find resolution to your issues ?</div>
          <button
            type="button"
            className={`${styles.ExitModalButton} bluefill_animate font14 fw600 colorFFF mt-20`}
            onClick={async () => {
              await onClickEvent(`${currentfaq}`, 'Exit pop up_Raise a complaint', 'Exit pop up_Raise a complaint');
              handleFaqRedirection();
            }}
          >
            Raise a complaint
          </button>
          <div
            tabIndex={0}
            role="button"
            onKeyDown={() => {}}
            className="font13 fw400 color777 mt-15 pointer"
            onClick={async () => {
              await clickTracker('cs_exitpopup_cancel', `${currentfaq?.toLowerCase()}_faq`);
              await onClickEvent(`${currentfaq}`, 'Exit pop up_Raise a complaint', 'Exit pop up_Raise a complaint');
              document.body.style.overflow = 'unset';
              if (projectId === 'csportal') {
                const liVal = 'click';
                const liTrd = `cta_maybelater`;
                const faqTypeVal = '';
                const othersData = [];
                const llTrd = '';
                await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
              }
              handleClose();
            }}
          >
            Maybe later
          </div>
        </div>
      </div>
    </section>
  );
}

ExitPopup.propTypes = {
  handleClose: PropTypes.func,
};
